import React, { Component } from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import FormContact from './FormContact';
import { TiLocationOutline, TiMail } from 'react-icons/ti';
import { FaFacebookF, FaFacebookMessenger } from 'react-icons/fa';
import { BsLine } from 'react-icons/bs';
import { TbPhoneCall } from 'react-icons/tb';

export class SectionContact extends Component {
  render() {
    const iconColor = '#FADF5B';

    return (
      <>
        {this.props.googlemaps ? 
        <section id="contact" className="section-nopadding">
          <Container fluid className="p-0">
            <iframe title="google maps" src={this.props.googlemaps} width="100%" height="400" style={{ border: 0, display: 'block' }} allowFullScreen="" loading="lazy" referrerPolicy="no-referrer-when-downgrade"></iframe>
            {/* <iframe title="google maps" src='https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3877.155340007404!2d100.3381519755946!3d13.6483129996801!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x30e2be87af961a1b%3A0x6674b17d68f1f9ce!2z4Lia4Lij4Li04Lip4Lix4LiXIOC5gOC4reC4qiDguJ7guLUg4Lie4Lil4Liy4Liq4LmB4Lie4LiEIOC4iOC4s-C4geC4seC4lA!5e0!3m2!1sth!2sth!4v1688996893463!5m2!1sth!2sth' width="100%" height="400" style={{ border: 0, display: 'block' }} allowFullScreen="" loading="lazy" referrerPolicy="no-referrer-when-downgrade"></iframe> */}
          </Container>
        </section>
        : ''}
        <section className="section section-contact ibg-primary" id={this.props.googlemaps ? '' : 'contact'}>
          <Container>
            <Row>
              <Col lg={6} md={12}>
                <h2 className='text-left text-white mb-0'>ส่งข้อความหาเรา</h2>
                <p className="text-white mb-4">ขอบคุณที่ติดต่อหาเรา! เรายินดีให้คำปรึกษา</p>
                <FormContact />
              </Col>
              <Col lg={6} md={12}>
                <div className="p-5">
                  {this.props.contents.map((item, index) => (
                    <Row key={index}>
                      <Col>
                        <h5><hr />{item.set1}</h5>
                        <h2>{item.set2}</h2>
                        <p>{item.set3}</p>
                      </Col>
                    </Row>
                  ))}
                  <Row className="mb-4">
                    <Col>
                      <ul className="social">
                        {this.props.linelink ? 
                        <li className="ms-2">
                          <a href={this.props.linelink} target="_blank" rel="noreferrer"><BsLine color={'#114777'} size={26} /></a>
                        </li>
                        : ''}
                        {this.props.facebook ? 
                        <li className="ms-2">
                          <a href={this.props.facebook} target="_blank" rel="noreferrer"><FaFacebookF color={'#114777'} size={26} /></a>
                        </li>
                        : ''}
                        {this.props.messenger ? 
                        <li className="ms-2">
                          <a href={this.props.messenger} target="_blank" rel="noreferrer"><FaFacebookMessenger color={'#114777'} size={26} /></a>
                        </li>
                        : ''}
                      </ul>
                    </Col>
                  </Row>
                  <ul className="contact">
                    <li className="d-flex mb-2">
                      <div><TiLocationOutline size={24} color={iconColor} /></div>
                      {/* <div className="ms-2">{this.props.address}</div> */}
                      <div className="ms-2 text-white">{this.props.address}</div>
                    </li>
                    <li className="d-flex mb-2">
                      <div><TiMail size={24} color={iconColor} /></div>
                      {/* <div className="ms-2"><a href={"mailto:" + this.props.email}>{this.props.email}</a></div> */}
                      <div className="ms-2 text-white"><a className="text-white" href={"mailto:" + this.props.email}>{this.props.email}</a></div>
                    </li>
                    <li className="d-flex mb-2">
                      <div><TbPhoneCall size={24} color={iconColor} /></div>
                      {/* <div className="ms-2"><a href={"tel:" + this.props.phone}>{this.props.phone}</a></div> */}
                      <div className="ms-2 text-white"><a className="text-white" href={"tel:" + this.props.phone}>{this.props.phone}</a></div>
                    </li>
                  </ul>
                </div>
              </Col>
            </Row>
          </Container>
        </section>
      </>
    )
  }
}

SectionContact.defaultProps = {
  contents: []
}

export default SectionContact